import { ICategoryItem, ICategoryLable, ICategoryTab } from 'redhotpie-shared-lib/interfaces/ICategory';
import categoryTabModel from './categoryTab';

export default class Category {
  id: string;
  isSelected: boolean;
  isSelecting: boolean;
  isSkip: boolean;
  title: string;
  header: string;
  labelTop: ICategoryLable;
  labelBottom: ICategoryLable;
  subContent: string;
  indexTab: number;
  contentTabs: ICategoryTab[];
  subTabs: any[];
  singleSelect: boolean;
  isMore: boolean;
  unit: string;
  active?: boolean;
  isShowMore?: boolean;

  constructor(props?: { id: string }) {
    this.id = props?.id || '';
    this.isSelected = false;
    this.isSelecting = false;
    this.isSkip = false;
    this.title = '';
    this.header = '';
    this.labelTop = { key: '', value: '' };
    this.labelBottom = { key: '', value: '' };
    this.subContent = '';
    this.indexTab = 0;
    this.contentTabs = [new categoryTabModel()];
    this.subTabs = [];
    this.singleSelect = false;
    this.isMore = false;
    this.unit = '';
    this.active = false;
    this.isShowMore = false;
  }

  static mappingObject(categoryData: any): ICategoryItem {
    if (categoryData) {
      const category = Object.assign(new Category(), categoryData);
      category.id = categoryData.id;
      return category;
    }
    return new Category();
  }
}
